var map = {
	"./atlassian.png": 1424,
	"./atlassianLicense.png": 784,
	"./aws.png": 9838,
	"./awsGuest.png": 1103,
	"./awsLicense.png": 7921,
	"./box.png": 1974,
	"./boxGuest.png": 1978,
	"./boxLicense.png": 6812,
	"./confluence.png": 8636,
	"./confluenceGuest.png": 1147,
	"./confluenceLicense.png": 2945,
	"./gcp.png": 3845,
	"./gcpGuest.png": 6842,
	"./gcpLicense.png": 5078,
	"./gitlab.png": 6152,
	"./gitlabGuest.png": 1804,
	"./gitlabLicense.png": 7045,
	"./miro.png": 1170,
	"./miroGuest.png": 6807,
	"./miroLicense.png": 2087,
	"./okta.png": 315,
	"./oktaGuest.png": 4812,
	"./oktaLicense.png": 7200,
	"./sophos_ztna.png": 7377,
	"./youtrack.png": 1623,
	"./youtrackGuest.png": 36,
	"./youtrackLicense.png": 8258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7748;